import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import SkeletonLoader from "../../../../../utilites/SkeltonLoader";
import { Button, Grid, Typography, Box, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, FormGroup } from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router";
import IosSwitch from "../../../../components/styled/Switch";
import { DeleteIcon, DownIcon, EditIcon } from "../../../../../assets/common-svg/CommonSvg";
import FormikControl from "../../../../components/common/FormikControl";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteRole, permissionsList, permissionsListWithUser, selectAllRoles, selectBmrRolesLoading, selectPermissionsList, updateRolesPermissions, updateRolesPermissionsWithUser } from "../../../../slices/roles";
import { selectBmrAllOnBoardUser } from "../../../../slices/onBoardUser";
import BreadCrumb from "../../../../../pages/breadcrumb/BreadCrumb";

const validationSchema = Yup.object().shape({
    permissions_ids: Yup.array()
        .of(Yup.number().required('Permissions is required')) // Validate each item as a number
        .min(1, 'At least one permissions is required'),
})

const ModulesPermissions = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const BreadCrumbData = location.state || [];
    const dispatch = useDispatch()
    const { rowId, userId } = useParams()
    const isLoading = useSelector(selectBmrRolesLoading)
    const allOnBoardUser = useSelector(selectBmrAllOnBoardUser)
    const allPermissionsList = useSelector(selectPermissionsList)
    const allRoles = useSelector(selectAllRoles)
    const [modulesList, setModulesList] = useState([])
    const [subModuleList, setSubModuleList] = useState([])
    const[title,setTitle] = useState('')
    const [initialValues, setInitialValues] = useState({
        module_ids: [],
        permissions_ids: [],
    })

    const fetchPermissions = async () => {
        if (userId) {
            await dispatch(permissionsListWithUser(userId))
        } else {
            await dispatch(permissionsList(rowId))
        }
    }

    const handleModulesAndPermission = async () => {
        const moduleIds = [];
        const permissionIds = [];
        const allmodules = [];
        const allSubModules = [];

        allPermissionsList.forEach((item) => {
            if (item.parent_id === null) {
                allmodules.push(item);
                item?.permissions?.forEach((perm) => {
                    if (perm.active === 1 || perm.active === null) {
                        permissionIds.push(perm.id);
                    }
                });
                if (item.active === 1) {
                    moduleIds.push(item.id);
                }
            } else {
                allSubModules.push(item);
                if (item.active === 1) {
                    item.permissions?.forEach((perm) => {
                        if (perm.active === 1 || perm.active === null) {
                            permissionIds.push(perm.id);
                        }
                    });
                }
            }
        });

        setInitialValues({
            module_ids: moduleIds,
            permissions_ids: permissionIds,
        });

        setModulesList(allmodules);
        setSubModuleList(allSubModules);
    }

    useEffect(() => {
        handleModulesAndPermission()
    }, [allPermissionsList]);


    useEffect(() => {
        fetchPermissions()
    }, [])

    const handleSubmit = async (values) => {
        if (userId) {
            await dispatch(updateRolesPermissionsWithUser({ data: { permissions_ids: values?.permissions_ids }, userId }))
            navigate("/bmr/on-board-user")
        } else {
            await dispatch(updateRolesPermissions({ data: values, rowId }))
            navigate("/bmr/roles-management")
        }
    };
    const handleDelete = async () => {
        await dispatch(deleteRole(rowId))
        navigate(`/bmr/roles-management`)
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: handleSubmit
    })

    useEffect(()=>{
     if (userId) {
            const userRoles = allOnBoardUser.items.find(op => op.id == userId)
             setTitle(`${userRoles?.name} ( ${userRoles?.role_details?.title} )`)
        } else {
            setTitle(`${allRoles?.find(op => op.id == rowId)?.title} `)
        }
    },[allOnBoardUser,userId])

    return (
        <div className="!p-6">
            {isLoading
                ? <SkeletonLoader rowCount={1} isTable={false} width="100%" height={100} />
                : <>    {BreadCrumbData && BreadCrumbData?.length > 0 &&
                    <div className="mb-4"><BreadCrumb BreadCrumbsListing={BreadCrumbData} /></div>}
                 <Box className="bg-[#171928] p-4 rounded-[6px]">
                    <Box className="flex justify-content-between align-items-center">
                        <Typography variant="h5" className="text-[#fff]">
                            {title}
                        </Typography>
                        {!userId &&
                            <div className="flex gap-2">
                                <Button
                                    startIcon={<EditIcon />}
                                    size="sm"
                                    onClick={() => navigate(`/bmr/roles-management/modules/${rowId}`,
                                        {
                                            state: [
                                                { name: "Role Management", path: '/bmr/roles-management'},
                                                { name: title, path: location.pathname },
                                                {
                                                name: 'Edit Modules',
                                                path: `/bmr/roles-management/modules/${rowId}`,
                                                },
                                            ],
                                        }
                                    )}
                                    className=" w-50 rounded-[6px] bg-[#171928] hover:bg-[#333b4a]  p-[10px]">
                                    Edit</Button>
                                <Button
                                    startIcon={<DeleteIcon />}
                                    size="sm"
                                    onClick={() => handleDelete()}
                                    // variant="outlined"
                                    className=" w-50  rounded-[6px] bg-[#171928] hover:bg-[#333b4a]  p-[10px]">Delete</Button>
                            </div>}
                    </Box>
                </Box></>}
            <div className="!p-4 mt-3 bg-white flex flex-col gap-4 rounded-[6px]">
                {isLoading
                    ? <div>
                        <SkeletonLoader rowCount={4} isTable={false} width="100%" height={100} />
                    </div>
                    : <form onSubmit={formik.handleSubmit} className="flex flex-col gap-6">
                        {modulesList.filter(v => !v.parent_id).map((module, index) =>
                            <Box className="border border-gray-200 p-3 rounded-md" key={index}>
                                <Grid container spacing={2} className="p-3">
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="mt-3">
                                        <div className="flex justify-content-between">
                                            <Typography variant="h5">{module.name}</Typography>
                                            <FormGroup>
                                                {(() => {
                                                    const existSubModule = module.permissions.length > 0 ? [module] : subModuleList.filter(v => v.parent_id === module.id);

                                                    // Extract all permission IDs from the found submodules
                                                    const allPermissionIds = existSubModule.flatMap(item =>
                                                        item.permissions ? item.permissions.map(p => p.id) : []
                                                    );

                                                    // Get the current permissions list from Formik
                                                    const currentPermissions = formik.values.permissions_ids || [];

                                                    // Check if ALL permission IDs exist in formik.values.permissions_ids
                                                    const isChecked = allPermissionIds.length > 0 && allPermissionIds.every(id => currentPermissions.includes(id));

                                                    return (
                                                        <FormControlLabel
                                                            control={<IosSwitch checked={isChecked} />}
                                                            onChange={(event) => {
                                                                const { checked } = event.target;
                                                                let updatedPermissions = [...currentPermissions]; // Clone the current array

                                                                if (checked) {
                                                                    // Add all missing permission IDs
                                                                    allPermissionIds.forEach(id => {
                                                                        if (!updatedPermissions.includes(id)) {
                                                                            updatedPermissions.push(id);
                                                                        }
                                                                    });
                                                                } else {
                                                                    // Remove all permission IDs
                                                                    updatedPermissions = updatedPermissions.filter(id => !allPermissionIds.includes(id));
                                                                }

                                                                // Update Formik field with the new array
                                                                formik.setFieldValue("permissions_ids", updatedPermissions);
                                                            }}
                                                        />
                                                    );
                                                })()}
                                            </FormGroup>
                                        </div>
                                        {module.permissions && module?.permissions?.length > 0 &&
                                            <Grid container spacing={2} className="p-3 m-3">
                                                <FormikControl
                                                    formik={formik}
                                                    name="permissions_ids"
                                                    type="switch"
                                                    options={module.permissions.map(permission => {
                                                        return { value: permission.id, label: permission.name }
                                                    })}
                                                />
                                            </Grid>}
                                        {subModuleList.filter(v => v.parent_id == module.id).map((subModule, subIndex) => (
                                            <Accordion defaultExpanded={true} className="w-100 mt-4" key={subIndex}>
                                                <AccordionSummary
                                                    expandIcon={<div className="d-flex gap-3 align-items-center">
                                                        <DownIcon />
                                                    </div>}
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"
                                                >
                                                    <Typography component="span">{subModule.name}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Grid container spacing={2} className="p-3 m-3">
                                                        <FormikControl
                                                            formik={formik}
                                                            name="permissions_ids"
                                                            type="switch"
                                                            options={subModule.permissions.map(permission => {
                                                                return { value: permission.id, label: permission.name }
                                                            })}
                                                        />
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Box>
                        )}

                        <div className="text-center">
                            {isLoading ? (
                                <SkeletonLoader rowCount={1} isTable={false} width="10%" height={25} />
                            ) : (
                                <Button fullWidth={false} sx={{ width: "100px" }} size="large" type="submit" variant="contained" color="primary">
                                    Update
                                </Button>
                            )}
                        </div>
                    </form>}
            </div>
        </div>
    );
};

export default ModulesPermissions;
